import React from 'react'

import { List } from 'antd'

const SectionsLegend = ({ sections }) => {
  return (
    <List
      dataSource={sections}
      renderItem={(section) => (
        <List.Item>
          <List.Item.Meta
            title={section.abbreviation}
            description={section.name}
          />
        </List.Item>
      )}
    />
  )
}

export default SectionsLegend
